import { RECENTS_PAGE, RECENTS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const recentsViewRoute = createGlobalRoute({
	exact: true,
	name: RECENTS_PAGE,
	path: RECENTS_PATH,
	resources: [],
	layout: 'home',
	subproduct: 'townsquare-home',
});
